import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=0da0d0ce&scoped=true&"
import script from "./Tables.vue?vue&type=script&lang=js&"
export * from "./Tables.vue?vue&type=script&lang=js&"
import style0 from "./Tables.vue?vue&type=style&index=0&id=0da0d0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0d0ce",
  null
  
)

export default component.exports